(() => {
  if (customElements.get('uq-header-navigation')) return;
  class UQHeaderNavigation extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.dropdowns = [...this.querySelectorAll('[data-uq-dropdown]')];
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1101px)');
      this.dropdowns.forEach(dropdown => {
        dropdown.addEventListener('toggle', () => {
          this.sync(dropdown);
          if (dropdown.open) this.closeOthers(dropdown);
        }, opts);
        dropdown.addEventListener('pointerenter', () => {
          if (!this.canHover.matches) return;
          clearTimeout(this.closeTimer);
          this.open(dropdown);
        }, opts);
        dropdown.addEventListener('pointerleave', () => {
          if (!this.canHover.matches || this.editorSelected === dropdown) return;
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(() => {
            if (!dropdown.matches(':hover') && !dropdown.contains(document.activeElement)) this.close(dropdown);
          }, 180);
        }, opts);
        dropdown.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (!dropdown.contains(document.activeElement) && !dropdown.matches(':hover') && this.editorSelected !== dropdown) this.close(dropdown);
          });
        }, opts);
        dropdown.addEventListener('pointerover', event => this.previewFromEvent(event, dropdown), opts);
        dropdown.addEventListener('focusin', event => this.previewFromEvent(event, dropdown), opts);
        this.sync(dropdown);
      });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeOthers();
      }, opts);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.dropdowns.find(dropdown => dropdown.open);
        if (!open) return;
        this.close(open);
        open.querySelector('summary')?.focus();
        event.preventDefault();
      }, opts);
      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        const link = blockId ? this.querySelector(`[data-uq-menu-item="${CSS.escape(blockId)}"]`) : event.target.querySelector('[data-uq-menu-item]');
        if (!link || !this.contains(link)) return;
        const dropdown = link.closest('[data-uq-dropdown]');
        this.editorSelected = dropdown;
        this.open(dropdown);
        this.preview(dropdown, link.dataset.uqMenuItem);
        if (!this.canHover.matches) {
          this.querySelector('.uq-header').classList.add('is-nav-open');
          this.querySelector('.uq-header__burger')?.setAttribute('aria-expanded', 'true');
        }
      }, opts);
      document.addEventListener('shopify:block:deselect', event => {
        if (this.contains(event.target)) this.editorSelected = null;
      }, opts);
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer);
      this.controller?.abort();
    }
    sync(dropdown) {
      dropdown.querySelector('summary')?.setAttribute('aria-expanded', String(dropdown.open));
    }
    open(dropdown) {
      this.closeOthers(dropdown);
      dropdown.open = true;
      this.sync(dropdown);
    }
    close(dropdown) {
      dropdown.open = false;
      this.sync(dropdown);
    }
    closeOthers(except) {
      this.dropdowns.forEach(dropdown => { if (dropdown !== except) this.close(dropdown); });
    }
    previewFromEvent(event, dropdown) {
      const link = event.target.closest('[data-uq-menu-item]');
      if (link && dropdown.contains(link)) this.preview(dropdown, link.dataset.uqMenuItem);
    }
    preview(dropdown, id) {
      dropdown.querySelectorAll('[data-uq-menu-photo]').forEach(photo => { photo.hidden = photo.dataset.uqMenuPhoto !== id; });
      dropdown.querySelectorAll('[data-uq-menu-item]').forEach(link => { link.classList.toggle('is-preview-active', link.dataset.uqMenuItem === id); });
    }
  }
  customElements.define('uq-header-navigation', UQHeaderNavigation);
})();
